import {UserInfoModel} from "../../../model/ua/user-info";
import {useAppDispatch, useAppSelector} from "../../../store/hook";
import React, {Fragment, ReactElement, useEffect, useState} from "react";
import {DbUserService} from "../../../services/db/dbUserService";
import {ResponseResultCode} from "../../../model/response-api";
import {DbUserConfigModel} from "../../../model/db/dbUserConfigModel";
import {toast} from "react-toastify";
import {showAndHideSpinner} from "../../../reducers/spinnerSlice";
import {DashboardUtils} from "../../../utils/dashboardUtils";
import DbUserTitle from "./DbUserTitle";
import {DashboardRowModel} from "./DbUserConfig";
import ArcButton from "../../../components/arc/ArcButton";
import {useNavigate} from "react-router-dom";

export default function DbUserCustom() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const spinner = useAppSelector(state => state.spinner);
  const userInfo: UserInfoModel = useAppSelector(state => state.userInfo.userInfo);
  const [dashboardConfigs, setDashboardConfigs] = useState<DbUserConfigModel[]>();
  const [dashboardRows, setDashboardRows] = useState<DashboardRowModel[]>();

  useEffect(() => {
    dispatch(showAndHideSpinner(true));
    DbUserService.getInstance().fetchUserConfigList().then((response) => {
      if (response && response.resultCode === ResponseResultCode.Y && response.data && Array.isArray(response.data)) {
        const tempDbUserConfigs: DbUserConfigModel[] = [];
        response.data.forEach((i) => tempDbUserConfigs.push(i));
        setDashboardConfigs(tempDbUserConfigs);
      } else {
        toast.error('대시보드 설정 정보를 불러오지 못했습니다.');
      }
    })
    .catch(() => toast.error('대시보드 설정 정보를 불러오는 과정 중 오류가 발생했습니다.'))
    .finally(() => dispatch(showAndHideSpinner(false)));
  }, []);

  useEffect(() => {
    const rows: DashboardRowModel[] = [];

    if (dashboardConfigs && Array.isArray(dashboardConfigs)) {
      if (dashboardConfigs.length > 0) {
        for (let i = 0; i < dashboardConfigs.length; i++) {
          if (i % 2 === 0) {
            const leftDiv = createDashboardModule(dashboardConfigs[i]);
            const rightDiv = (i + 1 <= dashboardConfigs.length - 1) ? createDashboardModule(dashboardConfigs[i + 1]) : <></>;
            rows.push({
              id: `dashboard-wrap-${i}`,
              element: (
                <div className="col-wrap">
                  {leftDiv}
                  {rightDiv}
                </div>
              )
            });
          }
        }
      } else {
        rows.push({
          id: `dashboard-wrap-error`,
          element: (
            <div className="w100 ac mgt20">
              <h2 style={{fontWeight: 600}}>나만의 대시보드를 설정해 보세요!</h2>
              <div>
                <ArcButton color="btn-style2" text="대시보드 설정하기" title="대시보드 설정하기" onClick={handleClickConfigButton}/>
              </div>
            </div>
          )
        });
      }
    } else {
      rows.push({
        id: `dashboard-wrap-error`,
        element: (
          <div className="w100 ac mgt20">
            <h2 style={{fontWeight: 600}}>대시보드 설정 정보를 불러오지 못했습니다.</h2>
            <h4>화면을 새로고침하여 다시 한 번 시도해 주세요.</h4>
          </div>
        )
      });
    }
    setDashboardRows(rows);
  }, [dashboardConfigs]);

  function createDashboardModule(config: DbUserConfigModel) {
    return DashboardUtils.getDashboardModuleByName(config.prsScrNm);
  }

  function handleClickConfigButton(e: any) {
    navigate('/db/user/config');
  }

  return (
    <div className="container">
      <div className="dashboard-wrap">
        <DbUserTitle title="나의 대시보드" configButtonVisible={true} />
        <div className='dashboard-wrap'>
          {!spinner.loading && dashboardConfigs && (
            <>
              {dashboardRows?.map((d) => <Fragment key={d.id}>{d.element}</Fragment>)}
            </>
          )}
        </div>
      </div>
    </div>
  );
}